import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import { getFilters } from "../../../common/config/filters";
import { baseFiltersPropTypeFactory, filtersPropTypeFactory } from "../../../common/constants/proptypes/filtersPropTypes";
import { valuedFilters } from "../../../common/utils/filters";
import { DISCOVER, SEARCH } from "../perspectives";
const facetType = PropTypes.oneOf(['disjunctive', 'conjunctive']);
export default {
  filtersContext: ImmutablePropTypes.contains({
    discoverFacetHrefResolver: PropTypes.func,
    searchFacetHrefResolver: PropTypes.func
  }),
  sortOption: ImmutablePropTypes.contains({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    indexSuffix: PropTypes.func.isRequired,
    exclusions: ImmutablePropTypes.map
  }),
  discoverFilters,
  facetType,
  hiddenFilters: ImmutablePropTypes.contains(baseFiltersPropTypeFactory(getFilters(), fvt => fvt).map(pt => PropTypes.oneOfType([PropTypes.bool, ImmutablePropTypes.setOf(pt)])).toJS()),
  perspective: PropTypes.oneOf([DISCOVER, SEARCH]),
  processedFacet: ImmutablePropTypes.contains({
    facetProducts: ImmutablePropTypes.listOf(ImmutablePropTypes.contains({
      count: PropTypes.number,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })),
    key: PropTypes.string.isRequired,
    sidebarLabel: PropTypes.string.isRequired,
    topBarLabel: PropTypes.string.isRequired,
    openByDefault: PropTypes.bool,
    primary: PropTypes.bool,
    type: facetType.isRequired
  })
};
function discoverFilters(props, ...rest) {
  return ImmutablePropTypes.contains(filtersPropTypeFactory(getFilters().filter(f => f.get('discoverFilter')), f => f.get('requiredDiscoverFilterWhenNonEmpty') && valuedFilters(props.filters).size).toJS())(props, ...rest);
}